module.exports = __webpack_public_path__ + "static/img/willian-justen-de-vasconcellos-4hMET7vYTAQ.93c2e05.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/articles/1911261/willian-justen-de-vasconcellos-4hMET7vYTAQ.jpg
// module id = qRZc
// module chunks = 1